var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandPointingWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.125v3.98c0 3.609-2.879 6.605-6.484 6.645a6.54 6.54 0 01-4.719-1.921c-1.704-1.803-3.629-6.204-3.629-6.204a1.25 1.25 0 01.51-1.736c.599-.313 1.336-.066 1.672.517l1.64 2.847a.476.476 0 00.47.241h.009a.64.64 0 00.531-.639V2.5a1.25 1.25 0 011.31-1.25c.673.032 1.19.611 1.19 1.284v5.591a.625.625 0 00.667.625.638.638 0 00.583-.644v-1.23a1.249 1.249 0 011.31-1.25c.673.03 1.19.61 1.19 1.283V8.75a.624.624 0 00.667.625.638.638 0 00.583-.644v-.569c0-.672.517-1.25 1.19-1.283a1.25 1.25 0 011.31 1.246z",
    fill: "#fff"
  })));
}

export default SvgHandPointingWhite;